import { render, staticRenderFns } from "./BookFlowerHousePreview.vue?vue&type=template&id=147b5f03&scoped=true"
import script from "./BookFlowerHousePreview.vue?vue&type=script&lang=js"
export * from "./BookFlowerHousePreview.vue?vue&type=script&lang=js"
import style0 from "./BookFlowerHousePreview.vue?vue&type=style&index=0&id=147b5f03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b5f03",
  null
  
)

export default component.exports